import { render, staticRenderFns } from "./AddORAskIQButton.vue?vue&type=template&id=3170a0b8&scoped=true"
import script from "./AddORAskIQButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AddORAskIQButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AddORAskIQButton.vue?vue&type=style&index=0&id=3170a0b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3170a0b8",
  null
  
)

export default component.exports